var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fullMode
    ? _c(
        "material-input",
        {
          staticClass: "position-relative fe-dp",
          class: {
            "form-group-material-no-label": !_vm.label,
            error: _vm.errorMessage,
          },
          attrs: { placeholder: _vm.placeholder },
        },
        [
          _c(
            "datepicker-input",
            _vm._b(
              {
                key: "datepicker",
                ref: "datepicker",
                attrs: {
                  id: _vm.labelValue,
                  name: _vm.name,
                  value: _vm.value,
                  placeholder: _vm.placeholder,
                  disabled: _vm.disabled,
                  "class-name":
                    _vm.className +
                    " " +
                    (_vm.value ? "form-control-filled" : ""),
                  tabindex: _vm.tabindex,
                  autocomplete: _vm.autocomplete,
                  "maturity-date": _vm.maturityDate,
                  "show-calendar":
                    _vm.calendar && !_vm.errorMessage && !_vm.disabled,
                },
                on: { change: _vm.handleChange },
              },
              "datepicker-input",
              _vm.$attrs,
              false
            )
          ),
          _vm._v(" "),
          _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
        ],
        1
      )
    : _c(
        "datepicker-input",
        _vm._b(
          {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: {
                  mask: "9999-99-99",
                  placeholder: "YYYY-MM-DD",
                  alias: "date",
                  greedy: false,
                  showMaskOnHover: false,
                },
                expression:
                  "{\n    mask: '9999-99-99',\n    placeholder: 'YYYY-MM-DD',\n    alias: 'date',\n    greedy: false,\n    showMaskOnHover: false\n  }",
              },
            ],
            key: "datepicker",
            ref: "datepicker",
            attrs: {
              name: _vm.name,
              value: _vm.value,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              "class-name":
                _vm.className + " " + (_vm.value ? "form-control-filled" : ""),
              tabindex: _vm.tabindex,
              autocomplete: _vm.autocomplete,
              "show-calendar": _vm.calendar && !_vm.errorMessage,
            },
            on: { change: _vm.handleChange },
          },
          "datepicker-input",
          _vm.$attrs,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }